import React, { Fragment, useState } from "react";
import { FormControl } from "baseui/form-control";
import { Input, SIZE } from "baseui/input";
import { useStyletron } from "baseui";
import { Textarea } from "baseui/textarea";
import { Radio, RadioGroup } from "baseui/radio";
import { ACCESS_TYPES } from "../../constants/AppEnums";
import { useTranslation } from "react-i18next";

export default function CreateTemplateModelerInfoView(props) {
  const [title, setTitle] = useState(props.title);
  const [description, setDescription] = useState(props.description);
  const [publicOrPrivate, setPublicOrPrivate] = useState(props.access);
  // const [modelerImage, setModelerImage] = useState(props.modelerImage);  
  const [css, ] = useStyletron();
  const { t } = useTranslation("template");
  

  return (
    <Fragment>
      <FormControl id="new-template-modeler-title" label={() => t('modelerTitle')}>
        <Input
        size={SIZE.mini}
          className={css({
            width: "100%",
          })}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onBlur={(e) => props.onModelerTitleChange(e.target.value)}
        />
      </FormControl>
      <FormControl id="new-template-modeler-description" label={() => t('modelerDescription')}>
        <Textarea
        size={SIZE.mini}
          value={description || ""}
          onChange={(e) => setDescription(e.target.value)}
          onBlur={(e) => props.onModelerDescriptionChange(e.target.value)}
          placeholder={t('promptModelerDescription')}
          clearOnEscape
        />
      </FormControl>
      <RadioGroup
        
        title="basic usage"
        onChange={(e) => {
          setPublicOrPrivate(e.target.value);
          props.onModelerAccessChanged(e.target.value);
        }}
        value={publicOrPrivate}
      >
        <Radio
          value={ACCESS_TYPES.PUBLIC}
          description={t('modelerPublicDescription')}
        >
          {t('modelerAccessPublic')}
        </Radio>
        <Radio
          value={ACCESS_TYPES.PRIVATE}
          description={t('modelerPrivateDescription')}
        >
          {t('modelerAccessPrivate')}
        </Radio>
      </RadioGroup>
    </Fragment>
  );
}
